import {
  Button,
  Link,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  VStack
} from "@chakra-ui/react"
import { useTranslate } from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ux/src/components/tooltip/Tooltip"
import { useUserPaymentHistoryQuery } from "../../api/generated"

const tPrefix = "payment_history"

export function useUserPaymentHistoryItems() {
  const userPaymentHistoryQuery = useUserPaymentHistoryQuery()
  const payments =
    userPaymentHistoryQuery.data?.me?.payment_history?.payments || []
  // Filtering out $0 payments.
  return payments.filter((payment) => payment.total > 0)
}

function UserAugmentationPaymentHistory() {
  const { t } = useTranslate()
  const userPaymentHistoryQuery = useUserPaymentHistoryQuery()
  const paymentHistory = userPaymentHistoryQuery.data?.me?.payment_history
  const payments = useUserPaymentHistoryItems()

  return (
    <VStack w="100%" minH="100%" p={2} pb={4} bg="white" borderRadius="20px">
      {userPaymentHistoryQuery.loading ? (
        <Spinner />
      ) : (
        <VStack spacing={8}>
          <Table
            variant="striped"
            layout="fixed"
            size="sm"
            w="100%"
            cellPadding={1}
          >
            <Thead fontWeight="bold">
              <Tr>
                <Td>{t(`${tPrefix}.item`)}</Td>
                <Td>{t(`${tPrefix}.total`)}</Td>
                <Td>{t(`${tPrefix}.date`)}</Td>
              </Tr>
            </Thead>
            <Tbody>
              {payments.map((payment, index) => (
                <Tr key={index}>
                  <Tooltip title={payment.item}>
                    <Td>
                      <Text noOfLines={1}>{payment.item}</Text>
                    </Td>
                  </Tooltip>
                  <Td>{payment.currency_display}</Td>
                  <Td>
                    {/* Formats like 06/04/2025 */}
                    {new Date(payment.date).toLocaleDateString(undefined, {
                      month: "2-digit",
                      day: "2-digit",
                      year: "numeric"
                    })}
                  </Td>
                </Tr>
              ))}
            </Tbody>
          </Table>
          <Button
            as={Link}
            variant="link"
            href={paymentHistory?.download_url}
            leftIcon={<Pathicon icon="download" />}
          >
            {t(`${tPrefix}.download_history`)}
          </Button>
        </VStack>
      )}
    </VStack>
  )
}

export default UserAugmentationPaymentHistory
